module.exports = ['$http', '$q', function($http, $q) {

	var searchURL = '/api/authoring/v1/search';
	
	/**
	* Returns a promise to the JSON for the search results
	* @param {String} query
	* @return {Promise}
	*/
	function getSearchResults(query) {
		return $http.get(searchURL + query).then(
			(res) => res.data,
			(res) => $q.reject(res)
		);
	}

	
	/**
	* Returns a promise to the JSON for the typeahead search results
	* @param {String} query
	* @return {Promise}
	*/
	function getTypeaheadSearchResults(query) {
		return $http.get(searchURL + query).then(
			(res) => res.data,
			(res) => $q.reject(res)
		);
	}
	
	// return public API for the REST factory
    return {
    	getSearchResults: getSearchResults,
    	getTypeaheadSearchResults: getTypeaheadSearchResults
    };
}];



// WEBPACK FOOTER //
// ./app/common/services/search-service.factory.js